/** Created by azhou on 2019/3/26.*/
<template>
  <div>
    <public-title>民宿活动审核</public-title>
    <div class="load-area">
      <el-tabs v-model="activeName" @tab-click="$GFUN.pageChange(1);getDataLists()">
        <el-tab-pane :name="item.id" v-for="item in tabArr" :key="item.id">
          <label slot="label">{{item.name}}
            <span class="unread-msg" v-if="waitVerify.homestayActi>0 && item.name==='未审核'">{{waitVerify.homestayActi}}</span>
          </label>
        </el-tab-pane>
      </el-tabs>
      <p v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</p>
      <div v-else>
        <ul class="list-head mt-3"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="item in AdminDataLists.lists" :key="item.id">
          <li class="w-50 list-item-col">
            <span class="text-link" @click="goStoreDetail(item.homestay_id)">{{item.homestay_title}}</span>
          </li>
          <li class="w-50 list-item-col">{{item.homestay_onsale_title | formatString(8)}}</li>
          <li class="w-50 list-item-col flex-column">
            <span>已添加 {{item.total_status_1 + item.total_status_0}} 个</span>
            <span class="text-success mt-1 mb-1">已发布 {{item.total_status_1}} 个</span>
            <span class="text-danger">待审核 {{item.total_status_0}} 个</span>
          </li>
          <li class="w-50 list-item-col">{{item.homestay_create_time | formatTimestamp(1)}}</li>
          <li class="w-50 list-item-col-end flex-wrap">
            <span class="text-link" @click="verifyItem(item)">{{activeName==='0'?'去审核':'查看'}}</span>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                       @current-change="$GFUN.pageChange"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters,mapActions,mapState } from 'vuex'

  export default {
    name: 'VerifyHomestayActi',
    computed: {
      ...mapState(['AdminDataLists','waitVerify']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
    },
    watch:{
      queryCon() { this.getDataLists(); },
    },
    data() {
      return {
        activeName:'0',
        titleArr:['民宿名称','活动名称','活动种类','添加时间','操作'],
        tabArr:[{name:'未审核',id:'0'},{name:'已审核',id:'1'}]
      }
    },
    created() { this.getDataLists(); },
    methods:{
      ...mapActions(['getAdminDataLists']),
      getDataLists() {
        this.getAdminDataLists({
          type:'homestayActi',
          data:{
            ...this.queryCon,
            status: this.activeName,
          }
        });
      },
      //查看门店详情
      goStoreDetail(id) {
        this.$router.push({name:'StoreDetail',query:{type:5,id}})
      },
      //去审核、查看
      verifyItem(item) {
        if (!this.$GFUN.powerIsInArray([137])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({
          name:'addEditActivity',
          query:{
            store:item.homestay_id,
            discount:item.homestay_onsale_id
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .unread-msg{
    top: 5px;
    left: 48px;
  }
</style>
